module.exports = __webpack_public_path__ + "img/compressed-1752137656290119680.b7139fb3.png";